export default __webpack_public_path__ + "static/media/bg.0e1775ec.jpg";